<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <search-jobs></search-jobs>
    <!-- end row -->
    </Layout>
</template>

<script>

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import SearchJobs from "../components/searchJobs.vue"
import routes from '../../../routes.js';

export default {
  page: {
    title: "searchJobs",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader,
    SearchJobs
  },
  data() {
    return {
      title: "Search Jobs",
      name: 'searchJobs',
      items: [
        {
          text: "home",
          href: '/'
        },
        {
            text: 'search jobs',
            href: '/production/jobs/searchJobs',
            active: true
        },
      ],
      routes: routes,
      
    }
  },

};

</script>